import React, { useEffect, useRef } from "react";

const VideoPlayerModal = ({ video, onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!video) return undefined;
    closeRef.current?.focus();
    // Capture phase so Escape closes the player without also closing the dossier behind it.
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [onClose, video]);

  if (!video) return null;

  const stopAndClose = (event) => {
    event.stopPropagation();
    onClose();
  };

  return (
    <div className="video-modal-backdrop" onClick={stopAndClose} role="presentation">
      <div
        className="video-modal"
        role="dialog"
        aria-modal="true"
        aria-label={video.title}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="video-modal-head">
          <p className="video-modal-title">{video.title}</p>
          <button ref={closeRef} type="button" className="clipboard-modal-close" onClick={stopAndClose}>
            Close
          </button>
        </header>
        <div className="video-modal-frame">
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
        <a
          className="video-modal-external"
          href={`https://www.youtube.com/watch?v=${video.id}`}
          target="_blank"
          rel="noreferrer"
        >
          Watch on YouTube ↗
        </a>
      </div>
    </div>
  );
};

export default VideoPlayerModal;
